(()=>{'use strict';
const root=window.MP_ROOT||'/',currency=window.MP_CURRENCY||'TRY';
const q=(s,r=document)=>r.querySelector(s),qa=(s,r=document)=>[...r.querySelectorAll(s)];
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const cash=c=>new Intl.NumberFormat(document.documentElement.lang||'tr',{style:'currency',currency}).format(c/100);
let busy=false,focusBeforeCart=null;
async function api(path,body){const response=await fetch(root+path,{credentials:'same-origin',headers:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},...(body?{method:'POST',body:JSON.stringify(body)}:{})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'İşlem tamamlanamadı. Lütfen tekrar dene.');return data}
function drawCart(cart){qa('.cart-count').forEach(e=>e.textContent=cart.item_count);q('#cart-content').innerHTML=cart.items.length?cart.items.map(item=>`<div class="cart-row">${item.image?`<img src="${esc(item.image)}" alt="${esc(item.product_title)}">`:'<span></span>'}<div><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3><p>${esc(item.variant_title||'')} · ${cash(item.final_price)}</p>${(item.line_level_discount_allocations||[]).map(d=>`<p>${esc(d.discount_application.title)} −${cash(d.amount)}</p>`).join('')}<div class="cart-row-bottom"><div class="quantity"><button data-live-key="${esc(item.key)}" data-live-qty="${item.quantity-1}" aria-label="${esc(item.product_title)} adedini azalt">−</button><span>${item.quantity}</span><button data-live-key="${esc(item.key)}" data-live-qty="${item.quantity+1}" aria-label="${esc(item.product_title)} adedini artır">＋</button></div><button class="remove" data-live-key="${esc(item.key)}" data-live-qty="0">Çıkar</button></div></div></div>`).join('')+`<div class="cart-total"><span>Ara toplam</span><strong>${cash(cart.total_price)}</strong></div>${(cart.cart_level_discount_applications||[]).map(d=>`<p>${esc(d.title)} −${cash(d.total_allocated_amount)}</p>`).join('')}<p class="cart-disclaimer">${cart.taxes_included?'Vergiler dahildir. ':'Vergiler ve '}Teslimat ödeme sırasında hesaplanır.</p><form action="${root}cart" method="post"><button class="button checkout" type="submit" name="checkout">Güvenli ödemeye geç ↗</button></form><a href="${root}cart" class="text-button">Sepeti düzenle / sipariş notu ↗</a><p class="errors" id="live-cart-error" role="alert"></p>`:`<div class="empty-cart"><p>Henüz bir şiir seçmedin.</p><a class="button" href="${root}collections/all">Koleksiyonu aç ↗</a></div>`}
window.MPopenCart=async()=>{const d=q('#cart-dialog');focusBeforeCart=document.activeElement;qa('dialog[open]').forEach(x=>x.close());q('#cart-content').innerHTML='<p role="status" style="padding-top:30px">Sepetin hazırlanıyor…</p>';d.showModal();try{drawCart(await api('cart.js'))}catch(e){q('#cart-content').innerHTML=`<p class="errors" role="alert">${esc(e.message)}</p><a class="button" href="${root}cart">Sepete git ↗</a>`}};
q('#cart-dialog')?.addEventListener('close',()=>focusBeforeCart?.focus());
document.addEventListener('click',async e=>{const cartLink=e.target.closest('a[data-cart],a[data-search]');if(cartLink)e.preventDefault();const b=e.target.closest('[data-live-key]');if(b&&!busy){busy=true;qa('[data-live-key]').forEach(x=>x.disabled=true);try{const next=await api('cart/change.js',{id:b.dataset.liveKey,quantity:Number(b.dataset.liveQty)});drawCart(next);q('#cart-title').tabIndex=-1;q('#cart-title').focus()}catch(error){if(q('#live-cart-error'))q('#live-cart-error').textContent=error.message}finally{busy=false;qa('[data-live-key]').forEach(x=>x.disabled=false)}}const gallery=e.target.closest('[data-gallery-src]');if(gallery&&q('#main-product-image')){q('#main-product-image').src=gallery.dataset.gallerySrc;q('#main-product-image').removeAttribute('srcset');q('#main-product-image').alt=gallery.dataset.galleryAlt}},true);
document.addEventListener('submit',async e=>{const form=e.target.closest('[data-product-form]');if(!form)return;e.preventDefault();if(busy)return;busy=true;const button=q('[data-live-add]',form),label=button.innerHTML;button.disabled=true;button.textContent='Ekleniyor…';q('[data-form-error]',form).textContent='';try{const fd=new FormData(form);const response=await fetch(root+'cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'},credentials:'same-origin'});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'Ürün eklenemedi.');await window.MPopenCart()}catch(error){q('[data-form-error]',form).textContent=error.message}finally{button.disabled=false;button.innerHTML=label;busy=false}});
document.addEventListener('change',e=>{if(!e.target.matches('[data-live-variant]'))return;const variants=JSON.parse(q('#product-variants').textContent),v=variants.find(v=>String(v.id)===e.target.value);if(!v)return;q('[data-live-price]').textContent=cash(v.price);q('[data-compare-price]').hidden=!(v.compare_at_price>v.price);q('[data-compare-price]').textContent=v.compare_at_price?cash(v.compare_at_price):'';const button=q('[data-live-add]');button.disabled=!v.available;button.innerHTML=v.available?'Sepete ekle <span>＋</span>':'Tükendi';if(v.featured_image&&q('#main-product-image')){q('#main-product-image').src=v.featured_image.src;q('#main-product-image').removeAttribute('srcset')}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(null,'',url)});
const catalog=window.MP_PRODUCTS||[];
if(!catalog.length)qa('[data-search]').forEach(b=>b.hidden=true);
if(catalog.length<2)q('.mood-switch')?.setAttribute('hidden','');
if(q('#hero-product')&&catalog[0]){q('#hero-product').href=catalog[0].url;q('#hero-product').setAttribute('aria-label',catalog[0].name+' hikâyesini oku');if(q('#hero-bottle')){q('#hero-bottle').src=catalog[0].image;q('#hero-bottle').alt=catalog[0].name}q('#hero-caption').innerHTML=esc(catalog[0].name)+'<small>'+esc(catalog[0].poet)+'</small>'}
// The full search page covers products, pages and articles beyond the two featured perfumes.
const results=q('#search-results');if(results){const a=document.createElement('a');a.href=root+'search';a.className='button outline';a.textContent='Tüm mağazada ara ↗';results.after(a)}
})();

/* MELANGE POETIQUE
   Monsieur Virgule | Sepet notlari
   Mevcut Shopify sepet koduna dokunmaz.
*/
(() => {
  'use strict';

  const messages = {
    empty: 'Henüz hiçbir şey seçmemişsiniz. Kararsızlık da bir sanattır, fakat pek güzel kokmaz.',
    day: "Baudelaire'i sepete koydunuz. Şairler bunu görseydi telif isterdi.",
    night: 'Geceyi seçtiniz. Sabahın bu karardan haberi yok.',
    both: 'Gündüz ve gece aynı sepette. Nihayet takvimle edebiyat anlaştı.',
    other: 'Güzel bir seçim. Mali durumunuza karışmam, ben edebiyatçıyım.'
  };

  const escapeHTML = value =>
    String(value ?? '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));

  function renderVirgule(cart) {
    const container = document.querySelector('#cart-content');
    if (!container || !cart) return;

    const handles = (cart.items || []).map(item =>
      String(item.handle || '').toLowerCase()
    );

    const day = handles.includes('la-chevelure');
    const night = handles.includes('vers-la-nuit');

    let message = messages.other;

    if (!cart.items.length) message = messages.empty;
    else if (day && night) message = messages.both;
    else if (day) message = messages.day;
    else if (night) message = messages.night;

    let note = container.querySelector('#virgule-cart-note');

    if (!note) {
      note = document.createElement('aside');
      note.id = 'virgule-cart-note';
      note.className = 'virgule-cart-note';

      const checkout = container.querySelector('.cart-total');
      const emptyCart = container.querySelector('.empty-cart');

      if (checkout) {
        checkout.before(note);
      } else if (emptyCart) {
        emptyCart.after(note);
      } else {
        container.append(note);
      }
    }

    note.innerHTML = `
      <div class="virgule-cart-note__label">
        ✳ LE MOT DE MONSIEUR VIRGULE
      </div>
      <p>${escapeHTML(message)}</p>
      <span class="virgule-cart-note__signature">
        M. Virgule, en marge.
      </span>
    `;
  }

  async function updateVirgule() {
    const container = document.querySelector('#cart-content');
    if (!container) return;

    try {
      const root = window.MP_ROOT || '/';
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin'
      });

      if (!response.ok) return;

      const cart = await response.json();
      renderVirgule(cart);
    } catch (error) {
      console.warn('Monsieur Virgule:', error);
    }
  }

  function init() {
    const container = document.querySelector('#cart-content');
    if (!container) return;

    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;

      queueMicrotask(() => {
        scheduled = false;

        if (!container.querySelector(
          '.cart-row, .empty-cart'
        )) return;

        updateVirgule();
      });
    });

    observer.observe(container, {
      childList: true,
      subtree: false
    });

    document.querySelector('#cart-dialog')
      ?.addEventListener('close', () => {
        // Sepet tekrar acildiginda guncel veri okunur.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
